import { bool } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { capitalize, Grid } from "@material-ui/core";
import classnames from "classnames";

export const SectionActions = observer(({
  fullActions,
  expanded,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {
        fullActions && expanded &&
        <Grid
          item container
          wrap="nowrap"
          justifyContent="flex-end"
          alignItems="center"
          className={classnames(
            "text-xs text-secondary",
          )}
        >
          <Grid
            item container
            className="mr-2 w-max"
          >
            { capitalize(t("times.hour")) }
          </Grid>
          <span className="w-56 mr-1">
            { t("views.editor.dialogs.timeline_settings.allocation") }
          </span>
        </Grid>
      }
    </>
  );
});

SectionActions.propTypes = {
  expanded: bool,
  fullActions: bool,
};